import React from "react";
import { Box, Grid, Typography, TextField, Button } from "@mui/material";
import { useForm } from 'react-hook-form';
import RFG from "../../libs/inputs/RFG";


export default function Form({ users, selectedUser, onChange, defaultValues = {}}) {
  const { handleSubmit, control, watch, setValue,clearErrors } = useForm({ defaultValues, mode: "all" });
  const [input, setInput] = React.useState("");
  const notification = watch("notification");
  const handleSend = () => {
    if (!input.trim()) return;
    onChange({ userId: selectedUser, message: input.trim() ,notification: watch("notification"),}, "send-message");
    setInput("");
  };
   

  return (
    
        <>
          <Box sx={{ flexGrow: 1, mb: 2 }}>
            <Typography>Messages panel </Typography>
          </Box>

          {/* Input + Send */}
          <Box sx={{ display: "flex", gap: 1, width: 1 }}>
             <RFG name="notification" label="Notification?" control={control}>
                            <input type="checkbox" onChange={(e) => setValue("notification", e.target.checked)}
                                checked={watch("notification")}/>
                          </RFG>
            <TextField
              fullWidth
              size="small"
              placeholder="Type a message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
            />
            <Button variant="contained" onClick={handleSend}>
              Send
            </Button>
          </Box>
        </>
  )
}
